import { render, staticRenderFns } from "./Remediation.vue?vue&type=template&id=71a283ef&"
import script from "./Remediation.vue?vue&type=script&lang=js&"
export * from "./Remediation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports